import { Outlet } from 'react-router-dom';
const DevLayout = () => (<div style={{ background: '#e5e8ed', minHeight: '957px', padding: '25px' }}>
        <Outlet />
    </div>);
export default DevLayout;
